module.exports = __webpack_public_path__ + "media/images/icons/download-audio-84c89eadcc3bede67ab39dd60f71dc4d.svg";